import React, { memo } from "react";

const Card = ({ header, img, footer, store }) => {
    return (
    <>
        <a href={store}>
            <div className="card mb-4 text-light">
                <div className="card-header bg-primary">
                    <h2>{header}</h2>
                </div>
                <div className="card-body bg-info">
                    <img src={img} alt={header} className={"card-img"} />
                </div>
                {footer}
            </div>
        </a>
    </>
    )
}

export default memo(Card);